module.exports = __webpack_public_path__ + "img/cl_mobile_withdraw.4ab78f8e.png";